module.exports = __webpack_public_path__ + "static/the-strategy-of-conflict-9df7a63dc4f3e3a8e035cfff6c78868c.jpg";